import React, { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { metaFriendlyString } from 'helpers/generalHelpers'
import { BreadCrumbLink } from 'components/Breadcrumb/breadcrumbLink'
import { GameWithoutLivestream } from '../../types'
import { getRichBreadcrumbMetaData } from 'meta/getRichBreadcrumbMetaData'
import { Company } from 'interfaces'

interface Props {
  channel: Company
  mediaObject: GameWithoutLivestream
  breadcrumbs?: BreadCrumbLink[]
}

export const VideoMeta: FC<Props> = ({ channel, mediaObject, breadcrumbs }) => {
  return (
    <Helmet prioritizeSeoTags>
      {mediaObject.title && (
        <>
          <meta
            property="og:title"
            content={metaFriendlyString(mediaObject.title)}
          />
          <meta
            name="twitter:title"
            content={metaFriendlyString(mediaObject.title)}
          />
        </>
      )}

      {mediaObject.description && (
        <>
          <meta
            name="description"
            content={metaFriendlyString(mediaObject.description)}
          />
          <meta
            property="og:description"
            content={metaFriendlyString(mediaObject.description)}
          />
          <meta
            name="twitter:description"
            content={metaFriendlyString(mediaObject.description)}
          />
        </>
      )}

      {mediaObject.thumbnail && (
        <>
          <meta property="og:image" content={mediaObject.thumbnail} />
          <meta
            property="og:image:secure_url"
            content={mediaObject.thumbnail}
          />
        </>
      )}

      <meta property="og:type" content="video.other" />
      <meta property="og:site_name" content={channel.name} />
      <meta property="og:locale" content={navigator.language} />

      <meta
        name="twitter:image"
        content={
          mediaObject.thumbnail || `${window.location.origin}/logo512.png`
        }
      />
      {breadcrumbs && (
        <script type="application/ld+json">
          {getRichBreadcrumbMetaData(breadcrumbs)}
        </script>
      )}
    </Helmet>
  )
}
